import {
  HTTP_UPDATEBUDGETMONTH_FETCHING,
  HTTP_UPDATEBUDGETMONTH_SUCCESS,
  HTTP_UPDATEBUDGETMONTH_FAILED,
} from "././../../Constants";

const initialState = {
  result: null,
  isLoading: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_UPDATEBUDGETMONTH_FETCHING:
      return { ...state, result: null, isLoading: true, isError: false };
    case HTTP_UPDATEBUDGETMONTH_SUCCESS:
      return { ...state, result: payload, isLoading: false, isError: false };
    case HTTP_UPDATEBUDGETMONTH_FAILED:
      return { ...state, result: null, isLoading: false, isError: true };
    default:
      return state;
  }
};
